import React,{useState} from 'react'
import "./styles/teach.css"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {  faPaperPlane} from '@fortawesome/free-solid-svg-icons'
import Footer from "./footer"


const Teach = () => {
 
 const [sectionChange,setSectionChange] = useState("tips")
    const  tipDetails = [{name:"Tips",value:"2,633"},{name:"Wins",value:"1,740"},{name:"Profit",value:"+575.06"},{name:"Draw",value:"99"},{name:"Win Rate",value:"66%"},{name:"ROI",value:"21.8%"}]

 const card = ["sport","binary","forex","crytptocurrency","sport","binary","forex","crytptocurrency"]
 const [tipsLevel,setTipsLever] = useState("ActiveTips")

const current = new Date();
  // const date = `${current.getDate()}/${current.getMonth()+1}/${current.getFullYear()}`;
  const date = `  ${current.getFullYear()}/${current.getMonth()+1}/${current.getDate()}`;
  return (
    <div className='lookUp'>
<div className='ParentDivNewHod'>
  

 
  <div style={{padding:"6px 8px"}}>
        <div className='profileCoverDiv'>
            <div className='BkPfo'>
                <div className="bkTopicH">Representing AI robotics as a digital Assets in blockchain</div>
            </div>

            <div className='holder7'> 
                <div className='holder2'>
                    <div className="point">
                        <img src="/img/bkPics.jpeg" alt="" className="ImgPicMan"/>
                         <img src="/img/picManImg.png" alt="" className="ImgPicMan1"/>
                    </div>
                    <div className='kingManU'>
                        <div className='AmosD78'>
                            <p className='namePad'>Kingsley C<span>.</span></p>
                    
                        </div>
                         <div className='AmosD78'>
                            <p className='holder5 tem1'>Software Developer</p>
                            <p className='tem'>{date}</p>
                         </div>
                     
                    </div>
                </div>
               
            </div>

   <div className="brif"> Passionate Software developer skilled in React, React-native, Nodejs, Express, SQL, HTML, CSS, Java, Python, and Django, committed to delivering high-quality and responsive solutions.</div>
           
          
        </div>
        </div>
 {/* section for tips */}

  
</div>

   <div>
        <div className='termsPage tem3'>
      <p className='termsPage1'>AI-Robot Tokenization on Blockchain</p>
      <p className='Pa'>Representing AI robotics as a digital asset on a blockchain can be achieved through a combination of IOT (internet of Things) devices, smart contracts, and tokenization.Here is simplified overview of this might work:</p>
      <p className='termPa'><span>1. </span> Device Integration</p>
      <p className='Pa'>Each AI robot is equipped with sensors and hardware that can generate data.This data might include performance metrics, operational status, location, and other relevant information.</p>
      <p className='termPa'><span>2. </span> Data Tokenization</p>
      <p  className='Pa'>The data generated by these robots can be tokenized,meaning its represented as digital tokens on a blockchain.These tokens can be uniquely linked to each robot and its specific data.</p>
      <p className='termPa'><span>3. </span> Smart Contracts</p>
      <p className='Pa'>Smart contracts can be created to govern the interactions and transactions involving these robot data tokens.For instance, contracts might specify conditions for renting,leasing, or selling robot data.</p>
      <p className='termPa'><span>4. </span> Ownership and Control</p>
      <p  className='Pa'>The ownership of a robot or its data can be transferred by transferring the associated tokens.Smart contracts can enforce the rules for transferring ownership and control. </p>
      <p className='termPa'><span>5. </span>Data Marketplace</p>
      <p  className='Pa'>A decentralized data marketplace could be established on the blockchain.Users, companies, or researchers interested utilizing AI robot data could purchase or rent these tokens to gain access to the data generated by the robots.</p>
      <p className='termPa'><span>6. </span> Utility Token</p>
      <p className='Pa'>Utility tokens within the ecosystem might be used for access to specific AI robot services, data analytics, or other functions related to the robots.</p>
      <p className='termPa'> Finally</p>
      <p className='Pa'>By incorporating AI robotics as digital assets on the blockchain , you can create a transparent, secure, and efficient way to manage ownership, data exchange, and access to AI robot services and data.This can be particularly valuable in scenarios like industrial automation, research, and development, where AI robotics play a crucial role.</p>
      
      
      </div>

    </div>

         

                
            </div>
  )
}

export default Teach